import { useDateSearchParamOrFallbackToToday } from "../../../hooks/useDateSearchParamOrFallbackToToday";
import { useSelectedServiceCenter } from "../../../hooks/useSelectedServiceCenter";
import AddRouteDialog from "./AddRouteDialog";
import { useActionsMenuContext } from "./ActionsMenuContext";

const AddRouteDefaultDialog = () => {
  const { closeDialog, shipments, clearSelection } = useActionsMenuContext();

  const [serviceCenter] = useSelectedServiceCenter();

  const [selectedDate] = useDateSearchParamOrFallbackToToday({
    useSicDate: true,
    timeZone: serviceCenter.timeZone,
  });

  const formatDate = (date: string) => Number(date.replaceAll("-", ""));

  return (
    <AddRouteDialog
      clearTableSelection={clearSelection}
      selectedShipments={shipments}
      title="Create New Manual Delivery Route"
      routeIntDate={formatDate(selectedDate)}
      onCancel={closeDialog}
      trailerSelected={null}
      tractorSelected={null}
      straightTruckSelected={null}
    />
  );
};

export default AddRouteDefaultDialog;
